// extracted by mini-css-extract-plugin
module.exports = {"reviews":"ItemReviews_reviews__3k_NV","reviewFormLayer":"ItemReviews_reviewFormLayer__3Uqko","fadeIn":"ItemReviews_fadeIn__2seKs","scaleXin":"ItemReviews_scaleXin__1-0zJ"};